import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import IEmployeeFunctionLink from 'types/company/payroll/IEmployeeFunctionLink';
import ISelectableFunctions from 'types/company/payroll/ISelectableFunctions';

export const getEmployeeFunctionLinksRequest = async (companyId: number): Promise<IEmployeeFunctionLink[]> => {
  const response: AxiosResponse<IEmployeeFunctionLink[]> = await getApi().get(
    `Company/${companyId}/EmployeeFunctionLinks`,
  );
  return response.data;
};

export const linkFunctionsToEmployeesRequest = async (props: {
  companyId: number;
  employeeIds: number[];
  functionIds: number[];
}): Promise<void> => {
  const { companyId, employeeIds, functionIds } = props;
  await getApi().post(`Company/${companyId}/EmployeeFunctionLinks`, { employeeIds, functionIds });
};

export const replaceLinkedFunctionsRequest = async (props: {
  companyId: number;
  employeeId: number;
  functionIds: number[];
}): Promise<void> => {
  const { companyId, employeeId, functionIds } = props;
  await getApi().put(`Company/${companyId}/EmployeeFunctionLinks/${employeeId}`, { functionIds });
};

export const unlinkAllFunctionsRequest = async (props: { companyId: number; employeeId: number }): Promise<void> => {
  const { companyId, employeeId } = props;
  await getApi().delete(`Company/${companyId}/EmployeeFunctionLinks/${employeeId}`);
};

export const unlinkFunctionRequest = async (props: {
  companyId: number;
  employeeId: number;
  functionId: number;
}): Promise<void> => {
  const { companyId, employeeId, functionId } = props;
  await getApi().delete(`Company/${companyId}/EmployeeFunctionLinks/${employeeId}/Functions/${functionId}`);
};

export const getLinkCountsByFunctionRequest = async (props: {
  companyId: number;
  functionIds: number[];
}): Promise<Record<number, number>> => {
  const { companyId, functionIds } = props;
  const query = functionIds.map(id => `functionIds=${id}`).join('&');
  const response: AxiosResponse<Record<number, number>> = await getApi().get(
    `Company/${companyId}/EmployeeFunctionLinks/CountsByFunction?${query}`,
  );
  return response.data;
};

export const getSelectableFunctionsRequest = async (props: {
  companyId: number;
  employeeIds: number[];
}): Promise<ISelectableFunctions> => {
  const { companyId, employeeIds } = props;
  const response: AxiosResponse<ISelectableFunctions> = await getApi().post(
    `Company/${companyId}/EmployeeFunctionLinks/SelectableFunctions`,
    { employeeIds },
  );
  return response.data;
};
